// import React, { useState, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { BiSave, BiX, BiBuilding, BiUser } from "react-icons/bi";
// import { API_BASE_URL } from "../utils/urls.js";

// // --- Reusable Section ---
// const FormSection = ({ title, icon, children }) => (
//   <div className="border border-gray-200 rounded-xl p-4 sm:p-6 bg-white shadow-sm">
//     <h2 className="text-lg sm:text-xl font-extrabold text-blue-800 mb-4 flex items-center space-x-2 border-b pb-2">
//       {icon}
//       <span>{title}</span>
//     </h2>
//     <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">{children}</div>
//   </div>
// );

// const CreateOrganizationForm = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     organizationName: "",
//     planName: "standard",
//     firstName: "",
//     lastName: "",
//     email: "",
//     password: "",
//   });

//   const [error, setError] = useState(null);
//   const [submitStatus, setSubmitStatus] = useState("");

//   const handleChange = useCallback((e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitStatus("submitting");
//     setError(null);
//     const token = localStorage.getItem("token");

//     try {
//       await axios.post(`${API_BASE_URL}/organizations`, formData, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setSubmitStatus("success");
//       setTimeout(() => navigate("/organizations"), 1500);
//     } catch (err) {
//       setSubmitStatus("error");
//       setError(err.response?.data?.message || "Submission failed.");
//     }
//   };

//   return (
//     <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-4xl mx-auto w-full">
//       <h1 className="text-2xl sm:text-4xl font-extrabold text-gray-800 mb-6 sm:mb-8 text-center sm:text-left">
//         Create New Organization
//       </h1>

//       <form onSubmit={handleSubmit} className="space-y-6 sm:space-y-8">
//         {/* --- Organization Section --- */}
//         <FormSection title="Organization Details" icon={<BiBuilding className="w-6 h-6" />}>
//           <div className="col-span-full">
//             <label htmlFor="organizationName" className="block text-sm font-medium text-gray-700 mb-1">
//               Organization Name *
//             </label>
//             <input
//               type="text"
//               id="organizationName"
//               name="organizationName"
//               value={formData.organizationName}
//               onChange={handleChange}
//               required
//               className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
//             />
//           </div>

//           <div>
//             <label htmlFor="planName" className="block text-sm font-medium text-gray-700 mb-1">
//               Plan Type *
//             </label>
//             <select
//               id="planName"
//               name="planName"
//               value={formData.planName}
//               onChange={handleChange}
//               className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
//             >
//               <option value="standard">Standard</option>
//               <option value="pro">Pro</option>
//               <option value="elite">Elite</option>
//             </select>
//           </div>
//         </FormSection>

//         {/* --- Admin Section --- */}
//         <FormSection title="Administrator Details" icon={<BiUser className="w-6 h-6" />}>
//           <div>
//             <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
//               Admin First Name *
//             </label>
//             <input
//               type="text"
//               id="firstName"
//               name="firstName"
//               value={formData.firstName}
//               onChange={handleChange}
//               required
//               className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
//             />
//           </div>

//           <div>
//             <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">
//               Admin Last Name *
//             </label>
//             <input
//               type="text"
//               id="lastName"
//               name="lastName"
//               value={formData.lastName}
//               onChange={handleChange}
//               required
//               className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
//             />
//           </div>

//           <div className="col-span-full">
//             <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
//               Admin Email *
//             </label>
//             <input
//               type="email"
//               id="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               required
//               className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
//             />
//           </div>

//           <div>
//             <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
//               Admin Password *
//             </label>
//             <input
//               type="password"
//               id="password"
//               name="password"
//               value={formData.password}
//               onChange={handleChange}
//               required
//               className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
//             />
//           </div>
//         </FormSection>

//         {/* --- Buttons --- */}
//         <div className="flex flex-col sm:flex-row justify-end sm:space-x-4 space-y-3 sm:space-y-0 pt-4">
//           <button
//             type="button"
//             onClick={() => navigate("/organizations")}
//             className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition w-full sm:w-auto"
//           >
//             <BiX className="inline-block w-5 h-5 mr-1" /> Cancel
//           </button>
//           <button
//             type="submit"
//             disabled={submitStatus === "submitting"}
//             className="px-5 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50 transition w-full sm:w-auto"
//           >
//             <BiSave className="inline-block w-5 h-5 mr-1" /> Create Organization
//           </button>
//         </div>

//         {/* --- Status Messages --- */}
//         {submitStatus === "success" && (
//           <p className="mt-4 text-green-500 text-center font-semibold">
//             ✅ Organization created successfully! Redirecting...
//           </p>
//         )}
//         {error && <p className="mt-4 text-red-500 text-center">{error}</p>}
//       </form>
//     </div>
//   );
// };

// export default CreateOrganizationForm;


import React, { useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BiSave, BiX, BiBuilding, BiUser } from "react-icons/bi";
import { API_BASE_URL } from "../utils/urls.js";

// --- Reusable Section ---
const FormSection = ({ title, icon, children }) => (
  <div className="border border-gray-200 rounded-xl p-4 sm:p-6 bg-white shadow-sm">
    <h2 className="text-lg sm:text-xl font-extrabold text-blue-800 mb-4 flex items-center space-x-2 border-b pb-2">
      {icon}
      <span>{title}</span>
    </h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">{children}</div>
  </div>
);

const CreateOrganizationForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    organizationName: "",
    planName: "standard",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    isExempt: false, // <-- NEW: Added to state
  });

  const [error, setError] = useState(null);
  const [submitStatus, setSubmitStatus] = useState("");
  const [logoFile, setLogoFile] = useState(null);

    // 2. Add this handler for the file input
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setLogoFile(e.target.files[0]);
    }
  };

  const handleChange = useCallback((e) => {
    // <-- NEW: Handle checkbox types correctly
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({ 
      ...prev, 
      [name]: type === "checkbox" ? checked : value 
    }));
  }, []);

  // 3. Update your handleSubmit function to upload the logo AFTER creating the org
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus("submitting");
    const token = localStorage.getItem("token");

    try {
      // First, create the organization
      const orgResponse = await axios.post(`${API_BASE_URL}/organizations`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      const newOrgId = orgResponse.data.organizationId;

      // Second, if a logo was selected, upload it
      if (logoFile && newOrgId) {
        const formUpload = new FormData();
        formUpload.append("logo", logoFile);

        await axios.post(`${API_BASE_URL}/super-admin/organizations/${newOrgId}/logo`, formUpload, {
          headers: { 
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data" 
          },
        });
      }

      setSubmitStatus("success");
      setTimeout(() => navigate("/organizations"), 1500);
    } catch (err) {
      setSubmitStatus("error");
      setError(err.response?.data?.message || "Submission failed.");
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-4xl mx-auto w-full">
      <h1 className="text-2xl sm:text-4xl font-extrabold text-gray-800 mb-6 sm:mb-8 text-center sm:text-left">
        Create New Organization
      </h1>

      <form onSubmit={handleSubmit} className="space-y-6 sm:space-y-8">
        {/* --- Organization Section --- */}
        <FormSection title="Organization Details" icon={<BiBuilding className="w-6 h-6" />}>
          <div className="col-span-full">
            <label htmlFor="organizationName" className="block text-sm font-medium text-gray-700 mb-1">
              Organization Name *
            </label>
            <input
              type="text"
              id="organizationName"
              name="organizationName"
              value={formData.organizationName}
              onChange={handleChange}
              required
              className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>

          <div>
            <label htmlFor="planName" className="block text-sm font-medium text-gray-700 mb-1">
              Plan Type *
            </label>
            <select
              id="planName"
              name="planName"
              value={formData.planName}
              onChange={handleChange}
              className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
            >
              <option value="standard">Standard</option>
              <option value="pro">Pro</option>
              <option value="elite">Elite</option>
            </select>
          </div>

          {/* --- NEW: Exempt Checkbox --- */}
          <div className="col-span-full mt-2 p-3 bg-gray-50 border rounded-lg">
            <label className="flex items-start space-x-3 cursor-pointer">
              <div className="flex items-center h-5">
                <input
                  type="checkbox"
                  id="isExempt"
                  name="isExempt"
                  checked={formData.isExempt}
                  onChange={handleChange}
                  className="w-5 h-5 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                />
              </div>
              <div className="flex flex-col">
                <span className="text-sm font-semibold text-gray-800">
                  Subscription Exempt / Lifetime Access
                </span>
                <span className="text-xs text-gray-500 mt-1">
                  Check this box if this organization is a lifetime account or internal testing account. It will bypass Stripe subscription requirements.
                </span>
              </div>
            </label>
          </div>
        </FormSection>

        {/* --- Admin Section --- */}
        <FormSection title="Administrator Details" icon={<BiUser className="w-6 h-6" />}>
          <div>
            <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
              Admin First Name *
            </label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
              className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>

          <div>
            <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">
              Admin Last Name *
            </label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
              className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Organization Logo (Optional)
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>

          <div className="col-span-full">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Admin Email *
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
              Admin Password *
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>
        </FormSection>

        {/* --- Buttons --- */}
        <div className="flex flex-col sm:flex-row justify-end sm:space-x-4 space-y-3 sm:space-y-0 pt-4">
          <button
            type="button"
            onClick={() => navigate("/organizations")}
            className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition w-full sm:w-auto"
          >
            <BiX className="inline-block w-5 h-5 mr-1" /> Cancel
          </button>
          <button
            type="submit"
            disabled={submitStatus === "submitting"}
            className="px-5 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50 transition w-full sm:w-auto"
          >
            <BiSave className="inline-block w-5 h-5 mr-1" /> Create Organization
          </button>
        </div>

        {/* --- Status Messages --- */}
        {submitStatus === "success" && (
          <p className="mt-4 text-green-500 text-center font-semibold">
            ✅ Organization created successfully! Redirecting...
          </p>
        )}
        {error && <p className="mt-4 text-red-500 text-center">{error}</p>}
      </form>
    </div>
  );
};

export default CreateOrganizationForm;
